import List from 'list.js'
import smoothscroll from 'smoothscroll-polyfill'
window.__forceSmoothScrollPolyfill__ = true
smoothscroll.polyfill()

const wrapper = document.querySelector('.wrapper')
const header = document.querySelector('.header')
const filters = document.querySelector('.filters')
const projects = document.querySelectorAll('.project')
const pages = document.querySelectorAll('.page')
const pageBtns = document.querySelectorAll('.nav__item>a')

const qs = (el, scope = document) => scope.querySelector(el)
const qsa = (el, scope = document) => scope.querySelectorAll(el)
const activate = (el, className = 'active') => el?.classList.add(className)
const deactivate = (el, className = 'active') => el?.classList.remove(className)
const isActive = (el, className = 'active') => el?.classList.contains(className) || false
const isMobile = () => wrapper.classList.contains('mobile')
const setVh = () => document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
const setMobile = () => (window.matchMedia('(max-width: 895px)').matches ? wrapper.classList.add('mobile') : wrapper.classList.remove('mobile'))
const setTop = () => document.documentElement.style.setProperty('--hh', `${header.offsetHeight}px`)
const scrollToValue = v => window.scrollY !== v && window.scroll({ top: v, behavior: 'smooth' })
const setAttributes = (el, attrs) => Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v))

// ---

function handleSlug() {
    const pathname = location.pathname

    // RANDOM PROJECT
    // if (pathname === '/projects' || pathname === '/projects/') {
    //     const slugs = Array.from(document.querySelectorAll('.project[data-slug]')).map(el => el.dataset.slug)
    //     const slug = slugs[Math.floor(Math.random() * slugs.length)]
    //     const project = qs(`.project[data-slug="${slug}"]`)
    //     if (!project) return
    //     activate(project)
    //     const row = qs('.project__row', project)
    //     return setTimeout(() => {
    //         window.scroll({ top: row.offsetTop - header.offsetHeight - filters.offsetHeight, behavior: 'instant' })
    //         history.replaceState(null, null, `/projects/${slug}`)
    //     }, 10)
    // }

    if (!pathname) return
    if (pathname.startsWith('/page/')) {
        const slug = pathname.replace('/page/', '')
        const page = qs(`.page[data-slug="${slug}"]`)
        if (!page) return

        activate(header)
        activate(page)
        activate(qs(`.nav__item>a[data-slug="${slug}"]`))
        activateHeaderM()
        setTop()
    } else if (pathname.startsWith('/projects/')) {
        const slug = pathname.replace('/projects/', '')
        const project = qs(`.project[data-slug="${slug}"]`)
        if (!project) return

        activate(project)
        const row = qs('.project__row', project)
        window.scroll({ top: row.offsetTop - header.offsetHeight - filters.offsetHeight, behavior: 'instant' })
    } else if (window.location.pathname === '/projects' && window.location.search.includes('search=true')) {
        const searchbar = document.querySelector('.search__input')
        activate(header)
        activateHeaderM()
        setTop()
        setTimeout(() => searchbar.focus(), 1)
        history.replaceState(null, null, '/projects')
    }
}

function initList() {
    let listObj = new List('listjs', { valueNames: ['project__name'], searchClass: 'listjs__search', searchDelay: 500 })

    // Close active project on search
    let listSearch = qs('.listjs__search'),
        listSearchResetBtn = qs('.search__reset-btn')

    if (!listSearch || !listSearchResetBtn) return

    listSearch.addEventListener('click', () => {
        deactivateFiltersM()
        resetActivePage()
        resetActiveProject()
        scrollToValue(0)
        setTop()
    })

    listSearch.addEventListener('input', () => {
        listSearch.value ? listSearchResetBtn.classList.add('active') : listSearchResetBtn.classList.remove('active')
    })

    listSearchResetBtn.addEventListener('click', () => {
        deactivate(listSearchResetBtn)
        listSearch.value = ''
        listObj.search()
    })

    let searchLogRow = qs('.search-m__log-row')
    searchLogRow.addEventListener('click', () => {
        deactivate(searchLogRow)
        deactivate(listSearchResetBtn)
        listSearch.value = ''
        listObj.search()
    })
}

function initFilters() {
    projects.forEach(project => {
        let size = project.getAttribute('data-size')
        if (size < 10000) project.classList.add('size-sm')
        if (size > 10000 && size <= 25000) project.classList.add('size-md')
        if (size > 25000 && size <= 250000) project.classList.add('size-lg')
        if (size > 250000) project.classList.add('size-xl')
    })

    isMobile() ? initFiltersMobile() : initFiltersDesktop()

    function initFiltersMobile() {
        const headerOpenBtn = qs('.header__open-btn')
        const selectsOpenBtnNodes = qsa('.selects-m__open-btn')
        const selectListNodes = qsa('.select-m__list')
        const selectsLogRow = qs('.selects-m__log-row')
        const selectsLogText = qs('.selects-m__log-text')
        const filtersOpenBtn = qs('.filters-m__open-btn')
        const sorts = qs('.sorts-m')
        const searchInput = qs('.search__input')
        const searchLogRow = qs('.search-m__log-row')
        const searchLogText = qs('.search-m__log-text')
        const loadmoreBtnNodes = qsa('.select__loadmore')

        let filterArray = []
        let filterTextArray = []
        let filterString = ''
        let filterTextString = ''

        const setEmptyClass = () => selectsLogRow.classList.toggle('empty', filterTextArray.length === 0)

        setEmptyClass()

        headerOpenBtn.addEventListener('click', function () {
            if (!isActive(this)) {
                resetActiveProject()
                resetActivePage()
                deactivateFiltersM()
                activateHeaderM()
                deactivate(selectsLogRow)
                setTop()

                deactivate(searchLogRow)
            } else {
                resetActivePage()
                deactivateHeaderM()
                deactivateFiltersM()
                // ---
                activate(selectsLogRow)
                let searchText = searchInput.value
                if (searchText) {
                    activate(searchLogRow)
                    searchLogText.innerText = 'Search: "' + searchText + '"'
                }
                // ---
                setTop()
            }
        })

        filtersOpenBtn.addEventListener('click', () => {
            qsa('.select-m__list.full').forEach(list => list.classList.remove('full'))
            resetActivePage()
            resetActiveProject()
            isActive(filtersOpenBtn) ? deactivate(filtersOpenBtn) : activate(filtersOpenBtn)
            isActive(sorts) ? deactivate(sorts) : activate(sorts)
            setTop()
        })

        selectsOpenBtnNodes.forEach(btn => {
            btn.addEventListener('click', () => {
                const thisSelectList = btn.nextElementSibling
                isActive(thisSelectList) ? deactivate(thisSelectList) : activate(thisSelectList)
                resetActivePage()
                resetActiveProject()
                setEmptyClass()
                setTop()
            })
        })

        selectListNodes.forEach(selectList => {
            qsa('.select-m__item', selectList).forEach(select => {
                select.addEventListener('click', () => {
                    resetActiveProject()
                    resetActivePage()

                    // reset previous active
                    const prevActive = qs('.select-m__item.active', selectList)
                    if (prevActive && prevActive !== select) {
                        const prevData = prevActive.getAttribute('data-select')
                        const prevText = prevActive.innerText
                        filterArray = filterArray.filter(f => f !== prevData)
                        filterTextArray = filterTextArray.filter(t => t !== prevText)
                        deactivate(prevActive)
                    }

                    // toggle current
                    const data = select.getAttribute('data-select')
                    const text = select.innerText
                    if (!isActive(select)) {
                        activate(select)
                        filterArray.push(data)
                        filterTextArray.push(text)
                    } else {
                        deactivate(select)
                        filterArray = filterArray.filter(f => f !== data)
                        filterTextArray = filterTextArray.filter(t => t !== text)
                    }

                    // update UI
                    filterString = filterArray.join('')
                    filterTextString = filterTextArray.join(', ')
                    selectsLogText.innerText = 'Filter: ' + filterTextString

                    // show all projects
                    qsa('.project.hidden').forEach(el => el.classList.remove('hidden'))

                    // hide filtered projects
                    if (filterArray.length) qsa(`.project:not(${filterString})`).forEach(el => el.classList.add('hidden'))

                    setEmptyClass()
                })
            })
        })

        selectsLogRow.addEventListener('click', () => {
            // reset arrays and log
            filterArray = []
            filterTextArray = []
            filterString = ''
            filterTextString = ''
            selectsLogText.innerText = ''

            // reset active selects
            qsa('.select-m__item.active').forEach(el => deactivate(el))

            // reset hidden projects
            qsa('.project.hidden').forEach(el => el.classList.remove('hidden'))

            // hide button
            deactivate(selectsLogRow)

            resetActiveProject()
            setEmptyClass()
            scrollToValue(0)
            setTop()
        })

        loadmoreBtnNodes.forEach(btn => {
            btn.addEventListener('click', () => {
                btn.parentElement?.classList.add('full')
                setTop()
            })
        })
    }

    function initFiltersDesktop() {
        const selects = qs('.selects')
        const selectsOpenBtnNodes = qsa('.selects__open-btn')
        const selectsResetBtn = qs('.selects__reset-btn')
        const selectListNodes = qsa('.select__list')
        const loadmoreBtnNodes = qsa('.select__loadmore')
        const filtersOpenBtn = qs('.filters__open-btn')

        let filterArray = []
        let filterString = ''

        const setEmptyClass = () => selects.classList.toggle('empty', filterArray.length === 0 && !isActive(selects))

        setEmptyClass()

        selectsOpenBtnNodes.forEach(btn => {
            btn.addEventListener('click', () => {
                isActive(selects) ? deactivate(selects) : activate(selects)
                resetActivePage()
                resetActiveProject()
                setEmptyClass()
            })
        })

        selectListNodes.forEach(selectList => {
            qsa('.select__item', selectList).forEach(select => {
                select.addEventListener('click', () => {
                    scrollToValue(0)
                    resetActiveProject()

                    // reset previous active
                    const prevActive = qs('.select__item.active', selectList)
                    if (prevActive && prevActive !== select) {
                        const prevData = prevActive.getAttribute('data-select')
                        filterArray = filterArray.filter(f => f !== prevData)
                        deactivate(prevActive)
                    }

                    // toggle current
                    const data = select.getAttribute('data-select')
                    if (!isActive(select)) {
                        activate(select)
                        filterArray.push(data)
                    } else {
                        deactivate(select)
                        filterArray = filterArray.filter(f => f !== data)
                    }

                    filterString = filterArray.join('')

                    // reset hidden projects
                    qsa('.project.hidden').forEach(el => el.classList.remove('hidden'))

                    if (filterArray.length) {
                        activate(selectsResetBtn)
                        qsa(`.project:not(${filterString})`).forEach(el => el.classList.add('hidden'))
                    } else {
                        deactivate(selectsResetBtn)
                    }

                    setEmptyClass()
                })
            })
        })

        selectsResetBtn.addEventListener('click', () => {
            filterArray = []
            filterString = ''

            qsa('.select__item.active').forEach(el => deactivate(el))
            qsa('.project.hidden').forEach(el => el.classList.remove('hidden'))

            deactivate(selectsResetBtn)
            resetActiveProject()
            setEmptyClass()
            scrollToValue(0)
        })

        loadmoreBtnNodes.forEach(btn => {
            btn.addEventListener('click', () => {
                btn.parentElement?.classList.add('full')
                setTop()
            })
        })

        filtersOpenBtn.addEventListener('click', () => {
            if (!isActive(selects)) {
                activate(selects)
                wrapper.classList.add('is_filters__open')
            } else {
                deactivate(selects)
                wrapper.classList.remove('is_filters__open')
                qsa('.select__list.full').forEach(list => list.classList.remove('full'))
            }

            isActive(filtersOpenBtn) ? deactivate(filtersOpenBtn) : activate(filtersOpenBtn)
            resetActivePage()
            resetActiveProject()
            setEmptyClass()
        })
    }
}

function initProject(project) {
    const row = qs('.project__row', project)
    const openBtn = qs('.project__name-btn', project)
    const text = qs('.project__text', project)
    const textBtn = qs('.project__text-btn', project)
    const closeBtn = qs('.project__close-btn', project)
    const thumbs = qs('.project__thumbs', project)
    const thumbNodes = qsa('.project__thumb', project)
    const previewImage = qs('.project__preview-image', project)

    let isHover = false

    openBtn.addEventListener('click', ev => {
        ev.preventDefault()
        if (isActive(project)) return

        resetActivePage()
        resetActiveSelects()
        deactivateHeaderM()

        qsa('.select__list.full').forEach(list => list.classList.remove('full'))

        if (previewImage.classList.contains('active-top')) previewImage.classList.remove('active-top')
        if (previewImage.classList.contains('active-bottom')) previewImage.classList.remove('active-bottom')

        if (isMobile()) {
            activate(qs('.selects-m__log-row'))
            const searchText = qs('.search__input')?.value
            if (searchText) {
                activate(qs('.search-m__log-row'))
                qs('.search-m__log-text').innerText = `Search: "${searchText}"`
            }
        }

        setTop()
        resetActiveProject()
        activate(project)
        window.scroll({ top: row.offsetTop - header.offsetHeight - filters.offsetHeight, behavior: 'smooth' })

        history.replaceState(null, null, `/projects/${project.getAttribute('data-slug')}`)
    })

    textBtn.addEventListener('click', () => {
        if (!isActive(textBtn)) {
            activate(text)
            activate(textBtn)
            scrollToValue(row.offsetTop - header.offsetHeight - filters.offsetHeight)
        } else {
            deactivate(text)
            deactivate(textBtn)
        }
    })

    thumbNodes.forEach(thumb => {
        thumb.addEventListener('click', function () {
            deactivateHeaderM()
            setTop()

            const thumbActive = qs('.project__thumb.active', project)
            if (thumbActive) thumbActive.classList.remove('active')

            if (!isActive(this)) {
                deactivate(text)
                deactivate(textBtn)
                activate(this)
                thumbs.scroll({ left: this.offsetLeft - thumbs.clientWidth / 2, behavior: 'smooth' })
                setMedia(project, thumb)
            }
        })
    })

    closeBtn.addEventListener('click', () => resetActiveProject())

    row.addEventListener('mouseenter', () => {
        if (isMobile()) return
        isHover = true
        setTimeout(() => {
            if (isHover && !project.classList.contains('active')) {
                const rowBottom = row.getBoundingClientRect().bottom
                const windowHeight = window.innerHeight
                previewImage.classList.add(rowBottom + windowHeight / 2 >= windowHeight ? 'active-top' : 'active-bottom')
            }
        }, 300)
    })

    row.addEventListener('mouseleave', () => {
        isHover = false
        if (!project.classList.contains('active')) {
            previewImage.classList.remove('active-top', 'active-bottom')
        }
    })

    if (!isMobile()) initImageZoom(project)
}

function initImageZoom(project) {
    const row = qs('.project__row', project)
    const image = qs('.project__image', project)
    const img = qs('.project__image img', project)
    const text = qs('.project__text', project)
    const textBtn = qs('.project__text-btn', project)
    const thumbNodes = qsa('.project__thumb', project)
    const parent = image
    const block = img

    let parentWidth
    let parentHeight
    let blockWidth
    let blockHeight
    let blockTop
    let blockLeft
    let blockBottom
    let blockRight
    let parentRect
    let mouseDownLeft
    let mouseDownRight
    let mouseDownTop
    let mouseDownBottom
    let mouseDownX
    let mouseDownY
    let clicked

    function mouseCalcValues(ev) {
        // parent
        parentWidth = parent.offsetWidth
        parentHeight = parent.offsetHeight
        parentRect = parent.getBoundingClientRect()
        mouseDownLeft = ev.pageX - parentRect.left
        mouseDownRight = (ev.pageX - parentRect.right) * -1
        mouseDownTop = ev.pageY - parentRect.top
        mouseDownBottom = (ev.pageY - parentRect.bottom) * -1

        // block
        blockWidth = block.offsetWidth
        blockHeight = block.offsetHeight
        blockTop = block.offsetTop
        blockLeft = block.offsetLeft
        blockBottom = parentHeight - (blockTop + blockHeight)
        blockRight = parentWidth - (blockLeft + blockWidth)
    }

    function mouseMove(ev) {
        let distFromParentLeft = blockLeft + (ev.pageX - parentRect.left) - mouseDownLeft,
            distFromParentTop = blockTop + (ev.pageY - parentRect.top) - mouseDownTop,
            distFromParentBottom = blockBottom - (ev.pageY - parentRect.bottom) - mouseDownBottom,
            distFromParentRight = blockRight - (ev.pageX - parentRect.right) - mouseDownRight

        let moveX = distFromParentLeft
        let moveY = distFromParentTop

        if (distFromParentLeft <= 0 && distFromParentRight <= 0) block.style.left = moveX + 'px'
        if (distFromParentTop <= 0 && distFromParentBottom <= 0) block.style.top = moveY + 'px'
    }

    function mouseStopMove(ev) {
        window.removeEventListener('mousemove', mouseMove)
    }

    block.addEventListener('mousedown', function (ev) {
        if (isActive(text)) {
            deactivate(text)
            deactivate(textBtn)
        }

        ev.preventDefault()

        mouseDownX = ev.pageX
        mouseDownY = ev.pageY
        clicked = true

        block.addEventListener('mouseup', function (ev) {
            if (clicked) {
                if (mouseDownX === ev.pageX && mouseDownY === ev.pageY) {
                    scrollToValue(row.offsetTop - header.offsetHeight - filters.offsetHeight)
                    if (image.classList.contains('zoomed')) {
                        image.style = ''
                        image.classList.remove('zoomed')
                    } else {
                        let zoom = 1.25
                        if (window.innerWidth < 1440) zoom = 1.5
                        if (window.innerWidth < 896) zoom = 2
                        image.style.height = img.offsetHeight + 'px' // set parent height
                        img.style.width = image.offsetWidth * zoom + 'px' // zoom el width
                        image.classList.add('zoomed')
                        if (image.classList.contains('zoomed')) {
                            // wait for zoom (bug) to set height
                            img.style.left = (image.offsetWidth - img.offsetWidth) / 2 + 'px' // get x center
                            img.style.top = (image.offsetHeight - img.offsetHeight) / 2 + 'px' // get y center
                        }
                    }
                }
                clicked = false
            }
        })

        if (image.classList.contains('zoomed')) {
            mouseCalcValues(ev)
            window.addEventListener('mousemove', mouseMove)
            window.addEventListener('mouseup', mouseStopMove)
        }
    })

    thumbNodes.forEach(thumb => {
        thumb.addEventListener('click', function () {
            image.classList.remove('zoomed')
            image.style = ''
        })
    })
}

function initPageBtn(pageBtn) {
    pageBtn.addEventListener('click', ev => {
        ev.preventDefault()

        resetActiveProject()
        resetActiveSelects()
        deactivateFiltersM()

        const pageActive = qs('.page.active')
        const pageBtnActive = qs('.nav__item>a.active')
        const pageSlug = pageBtn.getAttribute('data-slug')
        const pageContentMatch = qs(`.page[data-slug='${pageSlug}']`)

        if (pageActive && !isActive(pageBtn)) {
            deactivate(pageActive)
            if (pageBtnActive) deactivate(pageBtnActive)
            resetActivePage()
        }

        if (!isActive(pageBtn)) {
            activate(header)
            activate(pageBtn)
            activate(pageContentMatch)
            history.replaceState(null, null, `/page/${pageSlug}`)
        } else {
            resetActivePage()
        }

        setTop()
        scrollToValue(0)
    })
}

function initPage(page) {
    const tabs = qsa('.page__tab', page)
    const closeBtn = qs('.page__close-btn', page)

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const tabActive = qs('.page__tab.active', page)
            const tabContentActive = qs('.page__tab-content.active', page)
            const tabData = tab.getAttribute('data-tab')
            const tabContentMatch = qs(`.page__tab-content[data-tab-content='${tabData}']`, page)

            if (tabActive) deactivate(tabActive)
            if (tabContentActive) deactivate(tabContentActive)

            if (!isActive(tab)) {
                activate(tab)
                activate(tabContentMatch)
            }

            setTop()
        })
    })

    closeBtn.addEventListener('click', () => {
        resetActivePage()
        setTop()
    })
}

function init() {
    setMobile()
    setVh()
    setTop()

    initList()
    projects.forEach(initProject)
    pages.forEach(initPage)
    pageBtns.forEach(initPageBtn)

    handleSlug()
    initFilters()
    reloadPageOnResize()

    window.onpopstate = () => handleSlug()
    window.addEventListener('resize', () => {
        setMobile()
        setVh()
        setTop()
    })
}

init()

// ---

function reloadPageOnResize() {
    const query = '(max-width: 895px)'
    let current = window.matchMedia(query).matches ? 'mobile' : 'desktop'

    window.addEventListener('resize', () => {
        const next = window.matchMedia(query).matches ? 'mobile' : 'desktop'
        if (next !== current) {
            window.location.reload()
            current = next
        }
    })
}

function resetActiveSelects() {
    const filtersOpenBtn = qs('.filters__open-btn')
    const selects = qs('.selects')

    if (!qsa('.active', selects).length) selects.classList.add('empty')
    if (isActive(selects)) {
        deactivate(selects)
        wrapper.classList.remove('is_filters__open')
    }
    if (isActive(filtersOpenBtn)) deactivate(filtersOpenBtn)
}

function resetActivePage() {
    const activePage = qs('.page.active')
    if (!activePage) return

    deactivate(activePage)
    deactivate(qs('.nav__item>a.active'))
    deactivate(qs('.header.active'))

    history.replaceState(null, null, `${location.origin}/projects`)
}

function resetActiveProject() {
    const activeProject = qs('.project.active')
    if (!activeProject) return

    qsa('.active', activeProject).forEach(deactivate)
    deactivate(activeProject)

    qsa('.project__image.zoomed').forEach(image => {
        image.classList.remove('zoomed')
        image.style = ''
    })

    qsa('.project__video video').forEach(v => {
        v.pause()
        v.currentTime = 0
    })

    history.replaceState(null, null, `${location.origin}/projects`)
}

function deactivateFiltersM() {
    if (isMobile()) {
        const filtersOpenBtn = qs('.filters-m__open-btn')
        const sorts = qs('.sorts-m')
        const selectListActiveNodes = qsa('.select-m__list.active')

        deactivate(filtersOpenBtn)
        deactivate(sorts)
        selectListActiveNodes.forEach(el => deactivate(el))
    }
}

function activateHeaderM() {
    const headerOpenBtn = qs('.header__open-btn')
    const headerMenu = qs('.header__col--menu')

    if (isMobile() && !isActive(headerMenu)) {
        activate(headerMenu)
        activate(headerOpenBtn)
    }
}

function deactivateHeaderM() {
    const headerOpenBtn = qs('.header__open-btn')
    const headerMenu = qs('.header__col--menu')

    if (isMobile() && isActive(headerMenu)) {
        deactivate(headerMenu)
        deactivate(headerOpenBtn)
    }
}

function setMedia(project, thumb) {
    const row = qs('.project__row', project)
    const images = qs('.project__images', project)
    const video = qs('.project__video', project)
    const image = qs('.project__image', project)
    const thumbImg = qs('img', thumb)
    const thumbAlt = thumbImg.getAttribute('alt')
    const thumbSrc = thumbImg.getAttribute('data-src')

    // Activate the selected thumb
    activate(thumb)

    // Reset temp aspect-ratio
    qs('.project__image img', project).style = ''
    qs('.project__video video', project).style = ''

    // Preserve current height to avoid scroll jump
    let tempHeight = ''
    if (isActive(image)) tempHeight = qs('.project__image img', project).offsetHeight + 'px'
    else if (isActive(video)) tempHeight = qs('.project__video video', project).offsetHeight + 'px'
    images.style.height = tempHeight

    // If the thumb is a video
    if (thumb.classList.contains('video')) {
        if (isActive(image)) deactivate(image)
        activate(video)

        const videoElement = qs('.project__video video', project)
        const videoSrc = thumbImg.getAttribute('data-video-src')

        // Set title first, then source
        setAttributes(videoElement, { title: thumbAlt })
        fetch(videoSrc).then(res => {
            setAttributes(videoElement, { src: res.url })
            videoElement.play()
        })
    } else {
        // If the thumb is an image
        if (isActive(video)) {
            const videoElement = qs('.project__video video', project)
            videoElement.pause()
            videoElement.currentTime = 0
            deactivate(video)
        }
        activate(image)

        const imageElement = qs('.project__image img', project)

        // Set main image src
        setAttributes(imageElement, {
            'alt': thumbAlt,
            'src': thumbSrc,
            'data-src': thumbSrc,
            'srcset': '',
            'data-srcset': '',
        })

        // Load srcset if desktop
        if (!isMobile()) {
            const thumbSrcset = thumbImg.getAttribute('data-thumb-srcset')
            if (thumbSrcset) fetch(thumbSrcset).then(res => setAttributes(imageElement, { 'srcset': res.url, 'data-srcset': res.url }))
        }
    }

    const v = row.offsetTop - header.offsetHeight - filters.offsetHeight
    if (window.scrollY !== v) setTimeout(() => window.scroll({ top: v, behavior: 'smooth' }), 100)

    images.style.height = ''
}
